export default [
  {
    path: '/',
    name: 'login',
    component: () => import('../../views/Login/login')
  },
  { 
    // 首页
    path: '/index',
    name: 'index',
    hidden: true,
    component: () => import('../../views/Layout/index'),
    meta: {title: '主页', keepAlive: false},
    children: [{
      path: '',
      name: 'firstTab',
      component: () => import('../../views/Index/index'),
      meta: { title: '首页', noCache: true }
    }]
  },
]